export enum InterestStatus {
  Active = "Active",
  Removed = "Removed",
  MovedIn = "Moved In",
  ReinstatementRequested = "Reinstatement Requested",
}

export enum InterestStage {
  OnWaitlist = "On Waitlist",
  Removed = "Removed",
  MovedIn = "Moved In",
  ReinstatementRequested = "Reinstatement Requested",
}

export const STATUSES_INACTIVE = [
  InterestStage.Removed,
  InterestStage.MovedIn,
  InterestStage.ReinstatementRequested,
];

export const statusFromStage = (stage: string): InterestStatus => {
  switch (stage) {
    case InterestStage.Removed:
      return InterestStatus.Removed;
    case InterestStage.MovedIn:
      return InterestStatus.MovedIn;
    case InterestStage.ReinstatementRequested:
      return InterestStatus.ReinstatementRequested;
    default:
      return InterestStatus.Active;
  }
};

export const STATUSES_REASON_LABEL = {
  [InterestStage.Removed]: "Why are you removing this applicant?",
  [InterestStage.MovedIn]: "Additional notes",
};
